(function () {
    'use strict';

    angular
        .module('app')
        .controller('GamesAddController', GamesAddController);

    GamesAddController.$inject = ['debug', '$stateParams', 'API', '$state'];

    function GamesAddController(debug, $stateParams, API, $state) {
        var vm = this;
        vm.isAdding = false;
        vm.add = add;
        vm.game = {
            type: 'practice',
            sort_order: 12,
            missions_enabled: 1,
            age_from: 5,
            age_to: 10,
            translations: {},
            can_be_listed: 1,
            can_be_recommended: 1
        };

        function add() {
            if (!vm.isAdding) {
                vm.isAdding = true;

                var newGame = new API.Game(vm.game);

                var promise = newGame.$save();

                promise.then(function (response) {
                    $state.go('games.edit', { tag: response.tag });
                }, function (response) {
                    debug.log(response);
                })
                .finally(function() {
                    vm.isAdding = false;
                });
            }
        }
    }
})();